<template>
  <Swiper ref="productsSlider" v-bind="options">
    <slot></slot>
  </Swiper>
</template>

<script setup lang="ts">
import { Swiper } from 'swiper/vue'
import { Mousewheel } from 'swiper/modules'
import 'swiper/css'

const productsSlider = ref<any>(null)
const options = computed(() => {
  return {
    modules: [Mousewheel],
    loop: false,
    slidesPerView: 'auto' as const,
    equalHeight: true,
    spaceBetween: 8,
    mousewheel: {
      forceToAxis: true,
    },
  }
})
</script>

<style lang="postcss" scoped>
.swiper {
  overflow: visible !important;

  :deep(.swiper-wrapper) {
    height: auto !important;
  }
}
</style>
